import type { Emoji } from "@smartsuite/react-ui/lib";
import {
  EmojiPicker,
  MenuGroupContent,
  useEmojis,
} from "@smartsuite/react-ui/lib";
import { t } from "i18next";
import type { DynamicSection } from "../../../../../../../../types/line";
import { useState } from "react";

export const SlackEmojiOptions: React.FC<{
  onNavigateBack: () => void;
  selectedActionMenu?: DynamicSection;
  onChange: (input: string) => void;
}> = ({ onNavigateBack, onChange }) => {
  const [activeIndex, setActiveIndex] = useState(1);
  const { emojis, categories } = useEmojis({ searchQuery: "", isSlack: true });

  return (
    <MenuGroupContent
      maxHeight={1000}
      noPadding
      title={t("field-popups.emoji-popup")}
      onNavigateBack={onNavigateBack}
      search={false}
    >
      <EmojiPicker
        isSlack
        activeIndex={activeIndex}
        emojis={emojis}
        categories={categories}
        onClick={(emoji: Emoji) => {
          onChange(emoji.slackId ?? "");
        }}
        onActiveIndexChange={(activeIndex) => {
          setActiveIndex(activeIndex);
        }}
      />
    </MenuGroupContent>
  );
};
